import React from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Routings from "./Routing";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routings />
      </BrowserRouter>
    </>
  );
}

export default App;
